import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UtilsModule } from '@x/ecommerce-shop/app/core/utils/utils.module';
import { OrderItemAvailabilityComponent } from './order-item-availability.component';

@NgModule({
  declarations: [OrderItemAvailabilityComponent],
  imports: [CommonModule, MatChipsModule, MatTooltipModule, UtilsModule],
  exports: [OrderItemAvailabilityComponent],
})
export class OrderItemAvailabilityModule {}
